import {Button, Box, TextField, Typography} from '@material-ui/core'
import ReportsModal from 'modules/reports/components/Modal'
import ReportsModalActions from 'modules/reports/components/Modal/Actions'
import ReportsModalBody from 'modules/reports/components/Modal/Body'
import ReportsModalTitle from 'modules/reports/components/Modal/Title'
import React, {useState} from 'react'
import useStyles from './ReportsEmailModal.styles'
import DoneIcon from '@material-ui/icons/Done'
import useCore from 'modules/reports/hooks/core'
import Report from 'modules/reports/models/Report'
import ReportsEmailModalAdvanced from './Advanced'

type Props = {
  report: Report
}

const FORMATS = ['excel', 'csv', 'pdf']

function ReportsEmailModal(props: Props) {
  const {report} = props

  const classes = useStyles()
  const {p, pt, t} = useCore('reports', 'modals', 'Email')
  const [format, setFormat] = useState('excel')
  const [advanced, setAdvanced] = useState(false)

  function handleSend() {
    console.log('send')
  }

  function handleAdvanced() {
    setAdvanced(true)
  }

  function renderFormatButton(item: string) {
    const selected = format === item

    const buttonProps: any = {variant: 'outlined'}
    if (selected) buttonProps.variant = 'contained'

    return (
      <Button
        key={item}
        onClick={() => setFormat(item)}
        className={classes.formatButton}
        data-testid={`reports-email-modal-format-${format}`}
        {...buttonProps}
      >
        {selected && <DoneIcon className={classes.check} />} {t(`commons.file-format.${item}`)}
      </Button>
    )
  }

  return (
    <ReportsModal data-testid={p()} height={480}>
      <ReportsModalBody width={400}>
        <ReportsModalTitle>{pt('title')}</ReportsModalTitle>

        <div>
          <div>
            <TextField label={pt('send-to')} variant="outlined" data-testid={p('send-to')} />
          </div>

          <div>
            <TextField label={pt('subject')} variant="outlined" data-testid={p('subject')} />
          </div>

          <div>
            <TextField label={pt('body')} variant="outlined" data-testid={p('body')} multiline />
          </div>

          <Box marginTop={3}>
            <Typography>{pt('format')}</Typography>
            <div>{FORMATS.map(item => renderFormatButton(item))}</div>
          </Box>
        </div>

        <ReportsModalActions>
          <Button variant="contained" color="primary" onClick={handleSend} data-testid={p('send')}>
            {pt('send')}
          </Button>

          {!advanced && (
            <Button onClick={handleAdvanced} data-testid={p('advanced')}>
              {pt('advanced-button')}
            </Button>
          )}
        </ReportsModalActions>
      </ReportsModalBody>

      {advanced && <ReportsEmailModalAdvanced reportId={report.id} />}
    </ReportsModal>
  )
}

export default ReportsEmailModal
